module.exports = __webpack_public_path__ + "18156fc8d56f52c471411fdfed3e5996.jpg";